(() => {
  const normalizedSizeQuery = (value) => {
    const source = String(value || '').trim();
    const match = source.match(/^(\d+(?:\.\d+)?)\s*(?:-|\u2013|\u2014)\s*(\d+(?:\.\d+)?)\s*(?:mm)?$/i);
    return match ? `${match[1]}-${match[2]}mm` : source;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[role="search"]');
    const input = form?.querySelector('input[name="q"]');
    if (!input) return;
    input.value = normalizedSizeQuery(input.value);
  }, true);

  const currentUrl = new URL(window.location.href);
  if (currentUrl.pathname === '/search') {
    const original = currentUrl.searchParams.get('q') || '';
    const normalized = normalizedSizeQuery(original);
    if (normalized && normalized !== original) {
      currentUrl.searchParams.set('q', normalized);
      window.location.replace(currentUrl.toString());
    }
  }

  const predictiveRoot = document.querySelector('[data-header-search][data-predictive-search-url]');
  const predictiveInput = predictiveRoot?.querySelector('[data-search-input]');
  const predictiveResults = predictiveRoot?.querySelector('[data-predictive-search-results]');
  if (!predictiveRoot || !predictiveInput || !predictiveResults) return;

  let requestTimer;
  let requestController;
  const hidePredictiveResults = () => {
    predictiveResults.hidden = true;
    predictiveResults.replaceChildren();
    predictiveInput.setAttribute('aria-expanded', 'false');
  };
  const appendText = (parent, className, value) => {
    const element = document.createElement('span');
    element.className = className;
    element.textContent = value || '';
    parent.append(element);
  };
  const renderPredictiveResults = (products, query) => {
    predictiveResults.replaceChildren();
    for (const product of products) {
      const link = document.createElement('a');
      link.className = 'header-search__result';
      link.href = product.url;
      link.setAttribute('role', 'option');
      appendText(link, 'header-search__result-title', product.title);
      appendText(link, 'header-search__result-price', product.price);
      predictiveResults.append(link);
    }
    const allResults = document.createElement('a');
    allResults.className = 'header-search__all-results';
    allResults.href = `/search?q=${encodeURIComponent(normalizedSizeQuery(query))}&type=product`;
    allResults.textContent = 'View all results';
    predictiveResults.append(allResults);
    predictiveResults.hidden = false;
    predictiveInput.setAttribute('aria-expanded', 'true');
  };
  const fetchPredictiveResults = async () => {
    const query = predictiveInput.value.trim();
    if (query.length < 2) {
      hidePredictiveResults();
      return;
    }
    requestController?.abort();
    requestController = new AbortController();
    const predictivePath = predictiveRoot.dataset.predictiveSearchUrl.endsWith('.json')
      ? predictiveRoot.dataset.predictiveSearchUrl
      : `${predictiveRoot.dataset.predictiveSearchUrl}.json`;
    const endpoint = new URL(predictivePath, window.location.origin);
    endpoint.searchParams.set('q', query);
    endpoint.searchParams.set('resources[type]', 'product');
    endpoint.searchParams.set('resources[limit]', '6');
    endpoint.searchParams.set('resources[options][unavailable_products]', 'hide');
    try {
      const response = await fetch(endpoint, { signal: requestController.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`Predictive search failed (${response.status})`);
      const body = await response.json();
      const products = body?.resources?.results?.products || [];
      products.length ? renderPredictiveResults(products, query) : hidePredictiveResults();
    } catch (error) {
      if (error.name !== 'AbortError') hidePredictiveResults();
    }
  };

  predictiveInput.addEventListener('input', () => {
    window.clearTimeout(requestTimer);
    requestTimer = window.setTimeout(fetchPredictiveResults, 180);
  });
  document.addEventListener('click', (event) => {
    if (!predictiveRoot.contains(event.target)) hidePredictiveResults();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') hidePredictiveResults();
  });
})();
